<template>
<main class="container-right-nav">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <h2>Lista de mapas</h2>
    </div>

    <div class="container-body">

        <div class="list-item-area">
            <template 
            v-for="(item) in maps" >
                <span v-bind:key="item.index" class="list-item-name">
                    <router-link :to="'/mapas/' + item.id">{{item.name}}</router-link>
                </span>
                <span v-bind:key="item.index" class="list-item-sub-1" style="grid-column-end: 2;">{{dateFormatter(item.created_at)}}</span>
                <span v-bind:key="item.index" class="list-item-separator"></span>
            </template>

            <span v-if="!maps">No hay mapas</span>

        </div>

        <Pagination
        v-show="totalPages!=0"
        v-bind:totalPages="totalPages"
        v-bind:currentPage="currentPage"
        v-bind:pageSize="pageSize"
        v-on:pagechanged="pageChangedClick"
        >
        </Pagination>

    </div>

    <SideNav
    class="container-sidenav"
    v-bind:links="routesNav"
    >
    </SideNav>
    
</main>
</template>

<script>
// @ is an alias to /src
import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import Pagination from '@/components/Pagination.vue'

import {formatter} from '@/components/mixin/formatter.js'
import {pagination} from '@/components/mixin/pagination.js'
import {restMap} from '@/components/mixin/restMap.js'

export default{
    name: 'test',
    mixins: [formatter, pagination, restMap],
    data(){
        return{
            
        }
    },
    components:{
        SideNav,
        Breadcrumb,
        Pagination
    },
    computed: {
        routesNav: function(){
          return [
                {name:'Mapas'},
                {name:'Nuevo mapa' , path: '/mapas/nuevo-mapa'},
              ]
        },
        routesBread: function(){
          return [
              {name: 'Mapas'}
          ]
        }
    },
    props: [],
    methods:{
        pageChangedClick: function (page){
            this.currentPage = page;
            this.getMapsPages(this.currentPage);
        }
    },
    updated () {

    },
    created () {
        this.$store.getters.getPermissions.maps? true:this.$router.push('/pagina-no-encontrada')
    }, 
    mounted () {
        this.getMapsPages(this.currentPage);
    }
}
</script>

<style lang="scss" scoped>

</style>
